import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-custom-product-tags',
  templateUrl: './custom-product-tags.component.html',
  standalone: false
})
export class CustomProductTagsComponent {
  @Input() tags: string[];

}
